import React, { useEffect, useRef } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai, anonymousAI } from './ApplicationInsights';
import { RouteProps } from 'react-router-dom';
import { useNavigate, useLocation } from 'react-router-dom';
import Telemetry from './Telemetry';
import AnonymousTelemetry from './AnonymousTelemetry';

interface TelemetryProviderProps {
    instrumentationKey: string;
    children: React.ReactNode;
}

export const TelemetryContext = React.createContext<Telemetry>(new Telemetry());

const TelemetryProvider = (props: TelemetryProviderProps & RouteProps) => {
    const isTelemetryInitialized = useRef(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const { instrumentationKey } = props;
        const history = {
            location,
            push: navigate,
            listen: () => () => {
                // No-op listener required for Application Insights initialization
            },
        };
        if (!isTelemetryInitialized.current && instrumentationKey && history) {
            const applicationInsights = ai.initialize(
                instrumentationKey,
                history
            );
            const anonymousApplicationInsights = anonymousAI.initialize(
                instrumentationKey,
                history
            );
            AnonymousTelemetry.getInstance().setApplicationInsights(
                anonymousApplicationInsights
            );
            Telemetry.getInstance().setApplicationInsights(applicationInsights);
            isTelemetryInitialized.current = true;
        }
    }, [props, isTelemetryInitialized]);

    return (
        <TelemetryContext.Provider value={Telemetry.getInstance()}>
            {props.children}
        </TelemetryContext.Provider>
    );
};

export default withAITracking(ai.reactPlugin, TelemetryProvider);
